// A provisional material keeps its reference empty while using catalog pricing.
export function defaultMaterialSupplier(links, materialId, supplierId = '') {
  if (!materialId) return null;
  const candidates = links.filter((row) => row.material_id === materialId
    && row.is_active !== false && (!supplierId || row.supplier_id === supplierId));
  return candidates.find((row) => !row.supplier_ref?.trim() && row.is_primary)
    || candidates.find((row) => !row.supplier_ref?.trim())
    || candidates.find((row) => row.is_primary)
    || candidates[0] || null;
}
